(function () {
  const API_BASE = 'https://backend-prod-x9p4.onrender.com';
  const MOBILE_BREAKPOINT = 575;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  document.querySelectorAll('.url-checker').forEach(function (section) {
    const tabs = section.querySelectorAll('.url-checker__tab');
    const input = section.querySelector('.url-checker__input');
    const button = section.querySelector('.url-checker__button');
    const errorMessage = section.querySelector('.url-checker__error-message');
    const resultIcon = section.querySelector('.url-checker__result-icon');
    const resultInfo = section.querySelector('.url-checker__result-info');
    let activeTab = 'website';

    // Translatable labels from data attributes
    var labels = {
      button: section.dataset.labelButton || 'Check',
      allowed: section.dataset.labelAllowed || 'Allowed',
      blocked: section.dataset.labelBlocked || 'Blocked',
      conflictive: section.dataset.labelConflictive || 'Conflictive',
      pending: section.dataset.labelPending || 'Under review',
      notFound: section.dataset.labelNotFound || 'Website not found',
      fuzzyMatch: section.dataset.labelFuzzyMatch || 'Closest match',
      msgRateLimit: section.dataset.msgRateLimit || "You've reached your maximum daily checks. Your limit will reset tomorrow. Try again then.",
      msgNotFound: section.dataset.msgNotFound || 'App not found on Google Play.',
      msgAppNotFound: section.dataset.msgAppNotFound || "We couldn't find any app under that name.",
      msgPending: section.dataset.msgPending || "This website hasn't been categorized yet. It will be reviewed shortly.",
      msgUrlNotFound: section.dataset.msgUrlNotFound || "This website doesn't seem to exist. Please check the URL and try again.",
      msgInvalidUrl: section.dataset.msgInvalidUrl || 'Please enter a valid URL.',
      msgServiceError: section.dataset.msgServiceError || 'Service temporarily unavailable. Please try again later.',
      msgGenericError: section.dataset.msgGenericError || 'Something went wrong. Please try again.',
      msgConnectionError: section.dataset.msgConnectionError || 'Connection error. Please check your internet and try again.'
    };

    // Conflictive apps lookup — built from the metaobject JSON embedded in
    // the section. Matches on either package_name (preferred, if the backend
    // returns one) or app_name (case-insensitive against API's app_title).
    var conflictiveApps = (function () {
      var node = section.querySelector('.url-checker__conflictive-apps-json');
      if (!node) return [];
      try {
        var parsed = JSON.parse(node.textContent || '[]');
        if (!Array.isArray(parsed)) return [];
        return parsed
          .map(function (e) {
            return {
              package_name: (e && e.package_name ? String(e.package_name) : '').trim().toLowerCase(),
              app_name: (e && e.app_name ? String(e.app_name) : '').trim().toLowerCase(),
              reason: (e && e.reason ? String(e.reason) : '').trim()
            };
          })
          .filter(function (e) { return e.package_name || e.app_name; });
      } catch (err) {
        return [];
      }
    })();

    function findConflictiveMatch(data) {
      if (!conflictiveApps.length) return null;
      // Try every plausible field the API might return for the package id,
      // plus the human-readable title. First match wins.
      var packageCandidates = [data.package_name, data.app_id, data.appId, data.package, data.bundle_id]
        .filter(Boolean)
        .map(function (v) { return String(v).trim().toLowerCase(); });
      var nameCandidate = data.app_title ? String(data.app_title).trim().toLowerCase() : '';

      for (var i = 0; i < conflictiveApps.length; i++) {
        var entry = conflictiveApps[i];
        if (entry.package_name && packageCandidates.indexOf(entry.package_name) !== -1) {
          return entry;
        }
        if (entry.app_name && nameCandidate && entry.app_name === nameCandidate) {
          return entry;
        }
      }
      return null;
    }

    function getPlaceholder(tab) {
      var mobile = isMobile();
      if (tab === 'website') {
        return mobile
          ? input.dataset.placeholderWebsiteMobile
          : input.dataset.placeholderWebsite;
      }
      return mobile
        ? input.dataset.placeholderAppMobile
        : input.dataset.placeholderApp;
    }

    function updatePlaceholder() {
      input.placeholder = getPlaceholder(activeTab);
    }

    // Set initial placeholder
    updatePlaceholder();

    // Update placeholder on resize
    window.addEventListener('resize', updatePlaceholder);

    // Tab switching
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('url-checker__tab--active'); });
        tab.classList.add('url-checker__tab--active');
        activeTab = tab.dataset.tab;
        resetState();
        updatePlaceholder();
      });
    });

    // Check on button click
    button.addEventListener('click', function () {
      performCheck();
    });

    // Check on Enter key
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        performCheck();
      }
    });

    // Reset on input change
    input.addEventListener('input', function () {
      resetState();
    });

    function resetState() {
      input.classList.remove('url-checker__input--success', 'url-checker__input--error', 'url-checker__input--pending', 'url-checker__input--conflictive');
      resultIcon.classList.remove('url-checker__result-icon--visible');
      resultIcon.innerHTML = '';
      resultInfo.classList.remove('url-checker__result-info--visible', 'url-checker__result-info--allowed', 'url-checker__result-info--blocked', 'url-checker__result-info--conflictive', 'url-checker__result-info--pending', 'url-checker__result-info--not-found');
      resultInfo.innerHTML = '';
      errorMessage.classList.remove('url-checker__error-message--visible');
      errorMessage.textContent = '';
      button.classList.remove('url-checker__button--disabled');
      button.textContent = labels.button;
      delete section.dataset.appChecked;
      delete section.dataset.appCategory;
    }

    function setLoading(loading) {
      if (loading) {
        button.classList.add('url-checker__button--disabled');
        button.innerHTML = '<span class="spinner"></span>';
      } else {
        button.classList.remove('url-checker__button--disabled');
        button.textContent = labels.button;
      }
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    function extractDomain(url) {
      try {
        return new URL(url).hostname.replace(/^www\./, '');
      } catch (e) {
        return '';
      }
    }

    function showResult(data) {
      var status = data.status;
      var title = data.app_title || (data.url ? extractDomain(data.url) : '') || '';
      var color, stateClass, statusLabel, colorClass, iconSvg;

      if (status === 'conflictive') {
        // Computed CSS var falls back to the inline default if the section
        // didn't set --url-checker-conflictive-color.
        var computed = getComputedStyle(section).getPropertyValue('--url-checker-conflictive-color').trim();
        color = computed || '#d97706';
        stateClass = 'url-checker__input--conflictive';
        statusLabel = labels.conflictive;
        colorClass = 'url-checker__result-info--conflictive';
        iconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="' + color + '" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L1 21h22L12 2z"></path><line x1="12" y1="9" x2="12" y2="14"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>';
      } else if (status === 'allowed') {
        color = '#2e7d32';
        stateClass = 'url-checker__input--success';
        statusLabel = labels.allowed;
        colorClass = 'url-checker__result-info--allowed';
        iconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="' + color + '" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
      } else if (status === 'pending') {
        color = '#b8860b';
        stateClass = 'url-checker__input--pending';
        statusLabel = labels.pending;
        colorClass = 'url-checker__result-info--pending';
        iconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="' + color + '" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>';
      } else if (status === 'not_found') {
        color = '#adadad';
        stateClass = 'url-checker__input--error';
        statusLabel = labels.notFound;
        colorClass = 'url-checker__result-info--not-found';
        iconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="' + color + '" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';
      } else {
        // blocked
        color = '#c31111';
        stateClass = 'url-checker__input--error';
        statusLabel = labels.blocked;
        colorClass = 'url-checker__result-info--blocked';
        iconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="' + color + '" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line></svg>';
      }

      input.classList.add(stateClass);
      resultIcon.innerHTML = iconSvg;
      resultIcon.classList.add('url-checker__result-icon--visible');

      var html = '';
      if (title) {
        html += '<span class="url-checker__result-title">' + escapeHtml(title) + '</span> ';
      }
      html += '<span class="url-checker__result-status ' + colorClass + '">' + escapeHtml(statusLabel) + '</span>';

      // Show fuzzy match indicator for app results
      if (data.match_type === 'fuzzy') {
        html += ' <span class="url-checker__result-fuzzy">(' + escapeHtml(labels.fuzzyMatch) + ')</span>';
      }

      // Show subtitle message for pending and not_found
      if (status === 'pending') {
        html += '<br><span class="url-checker__result-reason">' + escapeHtml(labels.msgPending) + '</span>';
      } else if (status === 'not_found') {
        html += '<br><span class="url-checker__result-reason">' + escapeHtml(labels.msgUrlNotFound) + '</span>';
      }

      // Show reason for blocked or conflictive results when provided
      if ((status === 'blocked' || status === 'conflictive') && data.reason) {
        html += '<br><span class="url-checker__result-reason">' + escapeHtml(data.reason) + '</span>';
      }

      resultInfo.innerHTML = html;
      resultInfo.classList.add('url-checker__result-info--visible');
    }

    function showInlineError(message) {
      input.classList.add('url-checker__input--error');
      resultIcon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#c31111" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line></svg>';
      resultIcon.classList.add('url-checker__result-icon--visible');
      resultInfo.innerHTML = '<span class="url-checker__result-status url-checker__result-info--blocked">' + escapeHtml(message) + '</span>';
      resultInfo.classList.add('url-checker__result-info--visible');
    }

    function showError(message) {
      input.classList.add('url-checker__input--error');
      resultIcon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#c31111" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
      resultIcon.classList.add('url-checker__result-icon--visible');
      errorMessage.textContent = message;
      errorMessage.classList.add('url-checker__error-message--visible');
    }

    function normalizeUrl(value) {
      value = value.trim();
      if (!value) return '';
      if (!/^https?:\/\//i.test(value)) {
        value = 'https://' + value;
      }
      return value;
    }

    async function performCheck() {
      var rawValue = input.value.trim();
      if (!rawValue) return;

      resetState();
      setLoading(true);

      if (activeTab === 'app') {
        section.dataset.appChecked = 'true';
      }

      var endpoint, queryParam;
      if (activeTab === 'website') {
        endpoint = '/api/public/check-url/';
        queryParam = 'url=' + encodeURIComponent(normalizeUrl(rawValue));
      } else {
        endpoint = '/api/public/check-app/';
        queryParam = 'name=' + encodeURIComponent(rawValue) + '&include_category=true';
      }

      try {
        var response = await fetch(API_BASE + endpoint + '?' + queryParam);

        var data = await response.json();

        setLoading(false);

        if (response.status === 429) {
          showInlineError(labels.msgRateLimit);
          button.classList.add('url-checker__button--disabled');
          return;
        }

        if (response.status === 400) {
          var msg400 = labels.msgGenericError;
          if (data.error) {
            // Map backend error strings to user-friendly labels where available
            if (data.error.toLowerCase().includes('invalid url')) {
              msg400 = labels.msgInvalidUrl;
            } else if (data.error.toLowerCase().includes('missing')) {
              msg400 = labels.msgGenericError;
            } else {
              msg400 = data.error;
            }
          }
          showInlineError(msg400);
          return;
        }

        if (response.status === 404) {
          showInlineError(data.error || labels.msgNotFound);
          return;
        }

        if (response.status === 502) {
          showError(data.error || labels.msgServiceError);
          return;
        }

        if (!response.ok) {
          showError(data.error || labels.msgGenericError);
          return;
        }

        // App tab: if no app_title returned, show not-found
        if (activeTab !== 'website' && !data.app_title) {
          showInlineError(labels.msgAppNotFound);
          return;
        }

        if (activeTab === 'app' && typeof data.category === 'string') {
          section.dataset.appCategory = data.category.trim().toLowerCase();
        }

        // Conflictive apps override: if the matched app is in the metaobject
        // list, present it as "conflictive" (orange) with the metaobject's
        // reason, regardless of what the backend said.
        if (activeTab === 'app') {
          var conflictiveMatch = findConflictiveMatch(data);
          if (conflictiveMatch) {
            data.status = 'conflictive';
            if (conflictiveMatch.reason) {
              data.reason = conflictiveMatch.reason;
            }
          }
        }

        showResult(data);
      } catch (err) {
        setLoading(false);
        showError(labels.msgConnectionError);
      }
    }
  });
})();
